import {
  bookingListApi,
  operatorBookingList,
  bookingExcelDownload,
} from "Constant/apiConstant";
import { displayNotification } from "store/action";
import { request } from "utils/request";
export const BOOKING_LIST_UPCOMING_SUCCESS = "BOOKING_LIST_UPCOMING_SUCCESS";
export const BOOKING_LIST_UPCOMING_ERROR = "BOOKING_LIST_UPCOMING_ERROR";
export const BOOKING_LIST_UPCOMING_START = "BOOKING_LIST_UPCOMING_START";
export const BOOKING_LIST_ONGOING_START = "BOOKING_LIST_ONGOING_START";
export const BOOKING_LIST_ONGOING_ERROR = "BOOKING_LIST_ONGOING_ERROR";
export const BOOKING_LIST_ONGOING_SUCCESS = "BOOKING_LIST_ONGOING_SUCCESS";
export const BOOKING_LIST_CANCEL_START = "BOOKING_LIST_CANCEL_START";
export const BOOKING_LIST_CANCEL_ERROR = "BOOKING_LIST_CANCEL_ERROR";
export const BOOKING_LIST_CANCEL_SUCCESS = "BOOKING_LIST_CANCEL_SUCCESS";
export const BOOKING_LIST_COMPLETE_START = "BOOKING_LIST_COMPLETE_START";
export const BOOKING_LIST_COMPLETE_ERROR = "BOOKING_LIST_COMPLETE_ERROR";
export const BOOKING_LIST_COMPLETE_SUCCESS = "BOOKING_LIST_COMPLETE_SUCCESS";
export const BOOKING_LIST_UT_SUCCESS = "BOOKING_LIST_UT_SUCCESS";
export const BOOKING_LIST_OT_SUCCESS = "BOOKING_LIST_OT_SUCCESS";
export const BOOKING_LIST_CT_SUCCESS = "BOOKING_LIST_CT_SUCCESS";
export const BOOKING_LIST_CNT_SUCCESS = "BOOKING_LIST_CNT_SUCCESS";
export const BOOKING_LIST_ERROR = "BOOKING_LIST_ERROR";
export const BOOKING_LIST_START = "BOOKING_LIST_START";
export const COMPLETED_BOOKINGS_LIST_START = "COMPLETED_BOOKINGS_LIST_START";
export const COMPLETED_BOOKINGS_LIST_SUCCESS =
  "COMPLETED_BOOKINGS_LIST_SUCCESS";
export const COMPLETED_BOOKINGS_LIST_ERROR = "COMPLETED_BOOKINGS_LIST_ERROR";

const errorResponse = (dispatch) => {
  dispatch(
    displayNotification({
      open: true,
      message: "Something went wrong.",
      duration: 6000,
      severity: "error",
    })
  );
};
const bookingUpcomingListStart = () => {
  return { type: BOOKING_LIST_UPCOMING_START };
};
const bookingUpcomingListSuccess = (payload) => {
  return { type: BOOKING_LIST_UPCOMING_SUCCESS, payload };
};
const bookingUpcomingListError = (error) => {
  return { type: BOOKING_LIST_UPCOMING_ERROR, error };
};
const completedBookingsListStart = () => {
  return { type: COMPLETED_BOOKINGS_LIST_START };
};

const completedBookingsListSuccess = (payload) => {
  return { type: COMPLETED_BOOKINGS_LIST_SUCCESS, payload };
};

const completedBookingsListError = (error) => {
  return { type: COMPLETED_BOOKINGS_LIST_ERROR, error };
};

const bookingOngoingListStart = () => {
  return { type: BOOKING_LIST_ONGOING_START };
};
const bookingOngoingListSuccess = (payload) => {
  return { type: BOOKING_LIST_ONGOING_SUCCESS, payload };
};
const bookingOngoingListError = (error) => {
  return { type: BOOKING_LIST_ONGOING_ERROR, error };
};

const bookingCancelListStart = () => {
  return { type: BOOKING_LIST_CANCEL_START };
};
const bookingCancelListSuccess = (payload) => {
  return { type: BOOKING_LIST_CANCEL_SUCCESS, payload };
};
const bookingCancelListError = (error) => {
  return { type: BOOKING_LIST_CANCEL_ERROR, error };
};

const bookingCompletelListStart = () => {
  return { type: BOOKING_LIST_COMPLETE_START };
};
const bookingCompletelListSuccess = (payload) => {
  return { type: BOOKING_LIST_COMPLETE_SUCCESS, payload };
};
const bookingCompletelListError = (error) => {
  return { type: BOOKING_LIST_COMPLETE_ERROR, error };
};

const bookingListStart = () => {
  return { type: BOOKING_LIST_START };
};
const bookingUTListSuccess = (payload) => {
  return { type: BOOKING_LIST_UT_SUCCESS, payload };
};
const bookingOTListSuccess = (payload) => {
  return { type: BOOKING_LIST_OT_SUCCESS, payload };
};
const bookingCTListSuccess = (payload) => {
  return { type: BOOKING_LIST_CT_SUCCESS, payload };
};
const bookingCNTListSuccess = (payload) => {
  return { type: BOOKING_LIST_CNT_SUCCESS, payload };
};
const bookingListError = (error) => {
  return { type: BOOKING_LIST_ERROR, error };
};

const bookingListUpcomingData = (payload, callback) => (dispatch, getState) => {
  dispatch(bookingUpcomingListStart());
  try {
    request("POST", bookingListApi, payload, false)
      .then((res) => {
        if (res?.code === "200" || res?.code === "404") {
          dispatch(bookingUpcomingListSuccess(res?.data));
          // dispatch(
          //   displayNotification({
          //     open: true,
          //     message: "Form successfully submitted.",
          //     duration: 6000,
          //     severity: "success",
          //   })
          // );
          callback && callback(res);
        } else {
          dispatch(bookingUpcomingListError(res));
        }
      })
      .catch((err) => {
        console.log("bookingList error", err);
        dispatch(bookingUpcomingListError(err));
        dispatch(
          displayNotification({
            open: true,
            message: err?.response?.data
              ? err?.response?.data?.details[0]
              : "Something went wrong.",
            duration: 6000,
            severity: "error",
          })
        );
      });
  } catch (error) {
    dispatch(bookingUpcomingListError("Something went wrong"));
    dispatch(
      displayNotification({
        open: true,
        message: error?.response?.data
          ? error?.response?.data?.details[0]
          : "Something went wrong.",
        duration: 6000,
        severity: "error",
      })
    );
  }
};
const bookingListOngoingData = (payload, callback) => (dispatch, getState) => {
  dispatch(bookingOngoingListStart());
  try {
    request("POST", bookingListApi, payload, false)
      .then((res) => {
        if (res?.code === "200" || res?.code === "404") {
          dispatch(bookingOngoingListSuccess(res?.data));
          // dispatch(
          //   displayNotification({
          //     open: true,
          //     message: "Form successfully submitted.",
          //     duration: 6000,
          //     severity: "success",
          //   })
          // );
          callback && callback(res);
        } else {
          dispatch(bookingOngoingListError(res));
        }
      })
      .catch((err) => {
        console.log("bookingList error", err);
        dispatch(bookingOngoingListError(err));
        dispatch(
          displayNotification({
            open: true,
            message: err?.response?.data
              ? err?.response?.data?.details[0]
              : "Something went wrong.",
            duration: 6000,
            severity: "error",
          })
        );
      });
  } catch (error) {
    dispatch(bookingOngoingListError("Something went wrong"));
    dispatch(
      displayNotification({
        open: true,
        message: error?.response?.data
          ? error?.response?.data?.details[0]
          : "Something went wrong.",
        duration: 6000,
        severity: "error",
      })
    );
  }
};
const bookingListCancelData = (payload, callback) => (dispatch, getState) => {
  dispatch(bookingCancelListStart());
  try {
    request("POST", bookingListApi, payload, false)
      .then((res) => {
        if (res?.code === "200" || res?.code === "404") {
          dispatch(bookingCancelListSuccess(res?.data));
          // dispatch(
          //   displayNotification({
          //     open: true,
          //     message: "Form successfully submitted.",
          //     duration: 6000,
          //     severity: "success",
          //   })
          // );
          callback && callback(res);
        } else {
          dispatch(bookingCancelListError(res));
        }
      })
      .catch((err) => {
        console.log("bookingList error", err);
        dispatch(bookingCancelListError(err));
        dispatch(
          displayNotification({
            open: true,
            message: err?.response?.data
              ? err?.response?.data?.details[0]
              : "Something went wrong.",
            duration: 6000,
            severity: "error",
          })
        );
      });
  } catch (error) {
    dispatch(bookingCancelListError("Something went wrong"));
    dispatch(
      displayNotification({
        open: true,
        message: error?.response?.data
          ? error?.response?.data?.details[0]
          : "Something went wrong.",
        duration: 6000,
        severity: "error",
      })
    );
  }
};
const bookingListCompleteData = (payload, callback) => (dispatch, getState) => {
  dispatch(bookingCompletelListStart());
  try {
    request("POST", bookingListApi, payload, false)
      .then((res) => {
        if (res?.code === "200" || res?.code === "404") {
          dispatch(bookingCompletelListSuccess(res?.data));
          // dispatch(
          //   displayNotification({
          //     open: true,
          //     message: "Form successfully submitted.",
          //     duration: 6000,
          //     severity: "success",
          //   })
          // );
          callback && callback(res);
        } else {
          dispatch(bookingCompletelListError(res));
        }
      })
      .catch((err) => {
        console.log("bookingList error", err);
        dispatch(bookingCompletelListError(err));
        dispatch(
          displayNotification({
            open: true,
            message: err?.response?.data
              ? err?.response?.data?.details[0]
              : "Something went wrong.",
            duration: 6000,
            severity: "error",
          })
        );
      });
  } catch (error) {
    dispatch(bookingCompletelListError("Something went wrong"));
    dispatch(
      displayNotification({
        open: true,
        message: error?.response?.data
          ? error?.response?.data?.details[0]
          : "Something went wrong.",
        duration: 6000,
        severity: "error",
      })
    );
  }
};

const bookingListData = (payload, callback) => (dispatch, getState) => {
  console.log(payload);
  dispatch(bookingListStart());
  try {
    request("POST", operatorBookingList, payload, false)
      .then((res) => {
        if (res?.code === "200") {
          if (payload?.data?.type == "upcoming") {
            dispatch(bookingUTListSuccess(res?.data));
          }
          if (payload?.data?.type == "ongoing") {
            dispatch(bookingOTListSuccess(res?.data));
          }
          if (payload?.data?.type == "completed") {
            dispatch(bookingCTListSuccess(res?.data));
          }
          if (payload?.data?.type == "canceled") {
            dispatch(bookingCNTListSuccess(res?.data));
          }
          callback && callback(res);
        } else {
          dispatch(bookingListError(res));
          dispatch(
            displayNotification({
              open: true,
              message: "Something went wrong.",
              duration: 6000,
              severity: "error",
            })
          );
        }
      })
      .catch((err) => {
        console.log("bookingList error", err);
        dispatch(bookingListError(err));
        dispatch(
          displayNotification({
            open: true,
            message: err?.response?.data
              ? err?.response?.data?.details[0]
              : "Something went wrong.",
            duration: 6000,
            severity: "error",
          })
        );
      });
  } catch (error) {
    dispatch(bookingListError("Something went wrong"));
    dispatch(
      displayNotification({
        open: true,
        message: error?.response?.data
          ? error?.response?.data?.details[0]
          : "Something went wrong.",
        duration: 6000,
        severity: "error",
      })
    );
  }
};

function downloadByFileUrl(fileUrl, fileName) {
  let link = document.createElement("a");
  link.href = fileUrl;
  link.download = fileName;
  document.body.append(link);
  link.click();
  link.remove();
}

const completedBookingsFun = (payload, callback) => (dispatch, getState) => {
  // let tempPayload = JSON.parse(JSON.stringify(payload));
  // if (tempPayload.data.operator_id) {
  //   tempPayload.data.operator_id = window.btoa(tempPayload.data.operator_id);
  // }

  dispatch(completedBookingsListStart());
  try {
    request("POST", bookingExcelDownload, payload, false)
      .then((res) => {
        if (res?.code == "200") {
          dispatch(completedBookingsListSuccess(res?.data?.[0]));
          callback && callback(res?.data);
          downloadByFileUrl(res?.data?.[0]);
          // sucessfullResponse(dispatch);
        } else {
          errorResponse(dispatch);
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch(completedBookingsListError(err));
        errorResponse(dispatch);
      });
  } catch (error) {
    dispatch(completedBookingsListError("Something went wrong"));
    errorResponse(dispatch);
  }
};

export {
  bookingListData,
  bookingListUpcomingData,
  bookingListCompleteData,
  bookingListCancelData,
  bookingListOngoingData,
  completedBookingsFun,
};
